import { TokenHandler } from '@models/tokenHandler.model'
import { Helpers, LOCAL_STORAGE_KEY } from '@utils/helper'
import { LodashUtils } from '@utils/lodash'
import axios from 'axios'
import { postRefreshToken } from './authentication'

export const getSpCpHeader = () => {
  const spcpAuthCode = localStorage.getItem(LOCAL_STORAGE_KEY.SPCP_AUTH_HEADER)
  return {
    headers: {
      SpcpAuthCode: spcpAuthCode,
    },
  }
}

const protocol = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? '/',
})

const forceLogout = () => {
  Helpers.clearCachedData()
  window.location.href = '/login'
}

protocol.interceptors.request.use(function (config) {
  config.headers.set(
    'Content-Type',
    config.headers.get('Content-Type') ?? 'application/json',
  )
  return config
})

protocol.interceptors.response.use(
  (response) => {
    return LodashUtils.get(response, 'data', {})
  },
  async (error: any) => {
    const {
      response: { status, headers },
      config,
    } = error

    const isTokenExpired = TokenHandler.isExpiredToken(headers)
    if (isTokenExpired) {
      if (!TokenHandler.refreshing) {
        TokenHandler.refreshing = true
        postRefreshToken().catch((error) => {
          forceLogout()
          return Promise.reject(LodashUtils.get(error, 'response.data', {}))
        })
      }
      return new Promise((resolve) => {
        TokenHandler.cacheRequest((token: string) => {
          config.headers['Authorization'] = `Bearer ${token}`
          resolve(protocol(config))
        })
      })
    } else {
      if (status === 403 || status === 401) {
        forceLogout()
      }
    }
    return Promise.reject(LodashUtils.get(error, 'response.data', {}))
  },
)

export { protocol }
